<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">The Horse Who Went to Church</span></p>
<p class="p0">By Hilary Walker</p>
<p class="p2"><a id="a3"></a><span href="#/005#a12" title="Link target outside of Sample">Prologue</span></p>
<p class="p2"><span href="#/006#a13" title="Link target outside of Sample">Chapter 1: The Initial Dilemma</span></p>
<p class="p2"><span href="#/007#a14" title="Link target outside of Sample">Chapter 2: The Dilemma Goes Forth &amp; Multiplies</span></p>
<p class="p2"><span href="#/008#a15" title="Link target outside of Sample">Chapter 3: Behold, the Chase Continues</span></p>
<p class="p2"><span href="#/009#a16" title="Link target outside of Sample">Chapter 4: The Peeved Pastor</span></p>
<p class="p2"><span href="#/010#a17" title="Link target outside of Sample">Chapter 5: Mass Exodus</span></p>
<p class="p2"><span href="#/011#a18" title="Link target outside of Sample">Chapter 6: Virality</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?0f801cf2